<mat-toolbar class="Topbar" [class.Topbar--hijacking]="hijacker$ | async">
  <div class="flex items-center gap-2">
    <img class="Topbar__logo" *ngIf="!nav.opened" src="/assets/images/ab_logo--color.png" />
    <button mat-icon-button type="button" *ngIf="hasSidebar$ | async" (click)="toggleSideNav()">
      <mat-icon>menu</mat-icon>
    </button>

    <ng-container *awIsGod>
      <button
        mat-icon-button
        type="button"
        [matBadge]="env.name | shorten: 1 | ucfirst"
        [matMenuTriggerFor]="apiEnvMenu"
        [matMenuTriggerData]="{ envs: availableEnvs$ | async, activeEnv: env }"
        *ngIf="api.apiEnv$ | async as env"
        [matTooltip]="env.name + ': ' + env.url"
      >
        <mat-icon>api</mat-icon>
      </button>
    </ng-container>
    <div *ngIf="hijacker$ | async as hijackState" class="Topbar__pilot flex items-center justify-start">
      <mat-icon>fingerprint</mat-icon>
      Pilot: {{ hijackState.client.name }}
      <button matTooltip="Avbryt pilotläge" type="button" mat-icon-button (click)="cancelHijack()">
        <mat-icon>cancel</mat-icon>
      </button>
    </div>
  </div>
  <app-topbar-unit-tree class="flex flex-col flex-1 overflow-hidden" (onSelectUnit)="setActiveUnit($event)"></app-topbar-unit-tree>
  <div class="flex items-center flex-none">
    <ng-container *ngIf="messagesConfig$ | async as messagesConfig">
      <button
        mat-icon-button
        type="button"
        matTooltip="Meddelanden"
        [matBadge]="unreadThreads$ | async"
        [matBadgeHidden]="(unreadThreads$ | async) <= 0"
        matBadgePosition="above after"
        (click)="messagesButtonClicked($event)"
        *ngIf="messagesConfig.button"
      >
        <mat-icon>chat</mat-icon>
      </button>
    </ng-container>

    <button
      mat-icon-button
      type="button"
      (click)="toggleFeedbackDialog()"
      matTooltip="Skicka feedback"
      *ngIf="config.get('unitConfig.panel.feedback.enabled')"
    >
      <mat-icon>rate_review</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      matTooltip="Systemuppdateringar"
      [matBadge]="(systemNotices$ | async)?.length"
      [matBadgeHidden]="(systemNotices$ | async)?.length <= 0"
      matBadgePosition="above after"
      (click)="toggleSystemNoticesDialog($event)"
      *ngIf="config.get('unitConfig.panel.systemnotices.enabled')"
    >
      <mat-icon>update</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      matTooltip="Hjälpcenter"
      (click)="toggleHelpDialog($event)"
      *ngIf="config.get('unitConfig.panel.help.enabled')"
    >
      <mat-icon>help_outline</mat-icon>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="attendoHelpMenu">
      <mat-icon>help_outline</mat-icon>
    </button>

    <mat-menu #attendoHelpMenu>
      <ng-template matMenuContent>
        <a
          mat-menu-item
          href="https://api-attendo.appbolaget.se/@media/23f1614a-8307-4064-84bf-f03cb38ae230:faq?unit=23f1614a-8307-4064-84bf-f03cb38ae230"
          target="_blank"
        >
          <span>Ofte stillede spørgsmål</span>
        </a>
        <a
          mat-menu-item
          href="https://api-attendo.appbolaget.se/@media/23f1614a-8307-4064-84bf-f03cb38ae230:samtycke?unit=23f1614a-8307-4064-84bf-f03cb38ae230"
          target="_blank"
        >
          <span>Samtyckesblankett</span>
        </a>
        <a
          mat-menu-item
          href="https://api-attendo.appbolaget.se/@media/23f1614a-8307-4064-84bf-f03cb38ae230:manual-panel?unit=23f1614a-8307-4064-84bf-f03cb38ae230"
          target="_blank"
        >
          <span>Manual Attendo Naere Panel</span>
        </a>
        <a
          mat-menu-item
          href="https://api-attendo.appbolaget.se/@media/23f1614a-8307-4064-84bf-f03cb38ae230:manual-app?unit=23f1614a-8307-4064-84bf-f03cb38ae230"
          target="_blank"
        >
          <span>Manual Nære Mobilapp</span>
        </a>
      </ng-template>
    </mat-menu>

    <ng-container *ngIf="!config.get('unitConfig.panel.hideMediaInTopBar')">
      <button mat-icon-button type="button" matTooltip="Mediabibliotek" (click)="openMediaDialog()" *awIsGranted="'filesystem.read'">
        <mat-icon>perm_media</mat-icon>
      </button>
    </ng-container>

    <!-- <button class="Topbar__button" type="button" mat-button [matMenuTriggerFor]="apiLanguageMenu">
      <div class="flex items-center gap-2">
        <mat-icon>language</mat-icon>
        {{ languageService.getCurrentApiLanguage() }}
        <mat-icon>arrow_drop_down</mat-icon>
      </div>
    </button> -->

    <button
      class="Topbar__button"
      mat-button
      type="button"
      [matMenuTriggerFor]="menu"
      *ngIf="activeUnit$ | async as unit"
      [matMenuTriggerData]="{ unit: unit }"
    >
      <div class="flex gap-2 items-center">
        <mat-icon>account_circle</mat-icon>
        {{ (client$ | async).given_name }}
        <!-- <div class="Topbar__button__badge" [hidden]="!badge || (hasSidebar$ | async)"></div> -->
        <mat-icon>arrow_drop_down</mat-icon>
      </div>
    </button>
  </div>
  <mat-menu class="Topbar__menu" #menu="matMenu" xPosition="before" yPosition="below">
    <ng-template matMenuContent let-unit="unit">
      <button
        mat-menu-item
        type="button"
        [matMenuTriggerFor]="unitMenu"
        [matMenuTriggerData]="{ unit: unit }"
        (click)="goToUnit(unit)"
        *ngIf="units.length > 1"
      >
        <mat-icon>home</mat-icon>
        {{ unit.title }}
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="goToSettings()">
        <mat-icon>settings</mat-icon>
        {{ 'COMMON.SETTINGS' | translate }}
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item type="button" (click)="signout()"><mat-icon>lock</mat-icon> {{ 'COMMON.LOGOUT' | translate }}</button>
    </ng-template>
  </mat-menu>

  <mat-menu #unitMenu="matMenu" xPosition="before">
    <ng-template matMenuContent let-unit="unit">
      <button
        mat-menu-item
        type="button"
        *ngFor="let obj of units | orderBy: 'title'"
        (click)="setActiveUnit(obj)"
        [disabled]="obj.uuid === unit.uuid"
      >
        <div class="flex flex-col">
          <p class="Org-list__item__path" *ngIf="obj.attr('parents', 'json') as parents">
            <span *ngFor="let parent of $any(parents)">{{ parent.title }}</span>
          </p>
          <p class="Org-list__item__title">{{ obj.title }}</p>
        </div>
      </button>
    </ng-template>
  </mat-menu>

  <mat-menu #languageMenu="matMenu" xPosition="before">
    <button
      mat-menu-item
      type="button"
      *ngFor="let obj of languageService.languages | orderBy: 'title'"
      (click)="setLanguage(obj)"
      [disabled]="obj.code === languageService.activeLanguage"
    >
      <div class="flex flex-col">
        <p class="Org-list__item__title">{{ obj.title | translate }}</p>
      </div>
    </button>
  </mat-menu>
</mat-toolbar>

<mat-menu class="Topbar__menu" #apiLanguageMenu="matMenu" xPosition="before" yPosition="below">
  <button
    mat-menu-item
    type="button"
    *ngFor="let obj of languageService.apiLanguages | orderBy: 'title'"
    mat-menu-item
    (click)="setApiLanguage(obj)"
    [disabled]="obj.code === languageService.activeApiLanguage"
  >
    {{ obj.title | translate }}
  </button>
</mat-menu>

<mat-menu #apiEnvMenu="matMenu" xPosition="before">
  <ng-template matMenuContent let-envs="envs" let-activeEnv="activeEnv">
    <button mat-menu-item type="button" *ngFor="let env of envs" (click)="setApiEnv(env)" [disabled]="env.name === activeEnv.name">
      {{ env.name }}
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item type="button" (click)="setApiEnv(null)">Sätt default</button>
  </ng-template>
</mat-menu>
